/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Environment Index component for existing missions
Author: Deimos Space UK

Version: 1.0
*/

import React, { useEffect, useState } from "react";
import { Card, CardBody, Button, Row, Dropdown, Alert, DropdownToggle, DropdownMenu, Col } from "reactstrap";
import { getPetition } from "../../../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../../core/models/colors";
import Select, { components } from 'react-select';
import useDebounce from '../../../../hooks/useDebounce';
import Switch from "react-switch";
import { saveFile, rawDataIntoExcel } from "../../../../api/excel-api";


export default function EnvironmentIndex() {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [labelsBarChart, setLabelsBarChart] = useState([])
  const [dropdownOpenMission, setdropdownOpenMission] = useState(false);
  const toggle2 = () => setdropdownOpenMission((prevState) => !prevState);
  const [missionOptions, setMissionOptions] = useState([]);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState(false)
  const [exporting, setExporting] = useState(false)

  useEffect(() => {
    setMissionOptions([])
  }, [draft])

  useEffect(() => {
    if (optionsSelected.length === 0) {
      setLoading(true)
      getPetition('/api/debris_index/environment_index')
        .then((data) => {
          setError(false)
          setBarChartData(data.top_indices)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
          setError(true)
        })
    }
  }, [optionsSelected])
  const setBarChartData = (data) => {
    const barChartData = []
    data.map((item) => {
      barChartData.push({
        name: 'Mission ' + item.mission_name,
        value: item.index
      })
    })
    const labels = []
    const values = []

    barChartData.map((item) => {
      labels.push(item.name)
      values.push(item.value)
    })
    setLabelsBarChart(labels)
    setData(
      [
        {
          name: 'DEBRIS INDEX',
          data: values,
        },
      ]
    )
  }
  const chartContainerStyle = {
    width: '100%',
    height: 'auto',
  };
  const apexBarChartOpts = {
    chart: {
      height: 380,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,

      },
    },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val.toExponential(2)
      },

      style: {
        fontSize: '10px',
        colors: ['#fff'],
      },
    },
    colors: ESA_COLORS,
    stroke: {
      show: true,
      width: 0.2,
      colors: ['#fff'],
    },
    xaxis: {
      categories: labelsBarChart,
      labels: {
        show: true,
        rotateAlways: false,
        rotate:  -45 ,
        style: {
          colors: [],
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          color: '#000000',
          fontWeight: 'bold',
          cssClass: 'apexcharts-xaxis-label',
        },
        offsetX: 0,


      },
    },
    yaxis: {
      title: {
        text: 'Environmental index',
        style: {
          fontSize: '14px',
          color: '#000000',
          fontWeight: 'bold',
        },
      },
      labels: {
       
        formatter: function (val) {
          return  val.toExponential(0).toString() 
        },
        style: {
          colors: [],
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold',
          color: '#000000',
          cssClass: 'apexcharts-xaxis-label',
        },
      },
      forceNiceScale: false,
      tickAmount: 5,
    },
    legend: {
      show: false,
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true,
    },
    states: {
      hover: {
        filter: 'none',
      },
    },
    grid: {
      borderColor: '#f1f3fa',
    },
  };

  const formateOptions = (options) => {

    if (options.length > 0) {
      const optionsSelect = options.map((option) => ({
        value: option?.id || option?.value,
        label: option?.name || option?.label
      }))
      return optionsSelect
    }
  }
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const Control = ({ children, ...props }) => {

    return (
      <components.Control onChange={(e) => console.log(e)} {...props}>
        {children}
      </components.Control>
    );
  };

  const MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {/* menu header */}

        {props.children}
      </components.MenuList>
    );
  };
  const IndicatorsContainer = (props) => {
    const { inputValue, onInputChange } = props.selectProps;
    const debouncedInputValue = useDebounce(inputValue, 1000);
    useEffect(() => {
    if (debouncedInputValue !== '') {
      getPetition(`/api/missions?draft=${draft}&name=` + debouncedInputValue)
        .then((data) => {
          if (data.missions) {
            onInputChange('', { action: 'set-value' })
            setMissionOptions(data.missions)
          }
        })
    }
  }, [debouncedInputValue, onInputChange])
    return (
      <div style={{}}>
        <components.IndicatorsContainer {...props} className="input-group">

        </components.IndicatorsContainer>
      </div>
    );
  };
  const fetchDataToExcel = () => {
    if (optionsSelected.length > 0) {
      let missionIdParametres = '?'
      optionsSelected.map((item, index) => {
        if (index === 0) {
          missionIdParametres = missionIdParametres + 'mission_ids=' + item.value
        }
        else {
          missionIdParametres = missionIdParametres + '&mission_ids=' + item.value
        }
      })
      getPetition('/api/debris_index/environment_index' + missionIdParametres)
        .then((data) => {
          if (data.top_indices) {
            let excelRows = data.top_indices.map((item) => {
              return {
                "Mission Name": item.mission_name,
                "Index Value": item.index
              }
            })
            const excelData = rawDataIntoExcel(excelRows, "ENVIRONMENTAL INDEX")
            saveFile(excelData, 'ENVIRONMENTAL INDEX')
            setExporting(false)
          }
        })
        .catch((error) => {
          setError(true)
          setdropdownOpenMission(false)
        })
    } else {
      getPetition('/api/debris_index/environment_index')
        .then((data) => {

          if (data.top_indices) {
            let excelRows = data.top_indices.map((item) => {
              return {
                "Mission Name": item.mission_name,
                "Index Value": item.index
              }
            })
            const excelData = rawDataIntoExcel(excelRows, "ENVIRONMENTAL INDEX")
            saveFile(excelData, 'ENVIRONMENTAL INDEX')
            setExporting(false)
          }
        })
        .catch((error) => {
          setError(true)
          setdropdownOpenMission(false)
        })
    }

  }

  const getDataFromMissions = () => {
    setError(false)
    setdropdownOpenMission(false)
    let missionIdParametres = '?'
    optionsSelected.map((item, index) => {
      if (index === 0) {
        missionIdParametres = missionIdParametres + 'mission_ids=' + item.value
      }
      else {
        missionIdParametres = missionIdParametres + '&mission_ids=' + item.value
      }
    })
    getPetition('/api/debris_index/environment_index' + missionIdParametres)
      .then((data) => {
        setBarChartData(data.top_indices)
      })
      .catch((error) => {
        setError(true)
        setdropdownOpenMission(false)
      })
  }
  if (loading) {
    return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
      <Spinner animation="border" />
    </div>
  }

  return (
    <Card className="widget-flat h-100 ">
      <CardBody>
        <Row >
          <h4 style={{ color: '#003247' }} className="header-title float-left col " >ENVIRONMENTAL INDEX</h4>
          <Button onClick={() => fetchDataToExcel()} style={{ background: '#003247' }} className="float-right"><i className="uil  uil-down-arrow "></i></Button>
          <Dropdown isOpen={dropdownOpenMission} toggle={toggle2}>
            <DropdownToggle style={{ background: '#003247' }} className="float-right">+</DropdownToggle>
            <DropdownMenu style={{ width: '1000%', height: 'auto' }}>
              <Card>
                <CardBody>
                  <Row style={{ marginBottom: '10px' }}>
                    <Col xs={8}>
                      <h5 style={{ color: '#003247' }} className="header-title float-left col " >Select Missions</h5>
                    </Col>
                    <Col xs={4}>
                      <div style={{ display: 'flex', width: '100%', alignContent: 'center', justifyContent: 'right', }}>
                        <span style={{ color: '#003247', display: 'flex', marginLeft: 13, marginRight: 10 }} >Planned</span>
                        <Switch
                          checked={draft}
                          onChange={() => setDraft(!draft)}
                          onColor="#009bdb"
                          onHandleColor="#003247"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={15}
                          width={30}
                          handleDiameter={20}
                          className="react-switch"
                          id="material-switch"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="mb-2 position-relative">
                    <Select
                      placeholder={'Search...'}
                      options={formateOptions(missionOptions)}
                      isMulti={true}
                      components={{ Control, MenuList, IndicatorsContainer }}
                      maxMenuHeight="350px"
                      closeMenuOnSelect={false}
                      controlShouldRenderValue={true}
                      handleClick={onClick}
                      blurInputOnSelect={false}
                      isSearchable
                      isClearable
                      className="dropdown"
                      value={optionsSelected}
                      classNamePrefix="react-select"
                      onChange={(e) => setOptionsSelected(e)}
                    />
                    <Row>
                      {
                        optionsSelected.length > 0 && (
                          <Col>
                            <Button
                              onClick={() => {
                                setOptionsSelected([])
                                setdropdownOpenMission(false)
                              }}
                              className="btn btn-primary btn-block"
                              style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                            >
                              Clear
                            </Button>
                          </Col>
                        )
                      }
                      <Col>
                        <Button
                          onClick={() => { getDataFromMissions() }}
                          className="btn btn-primary btn-block"
                          style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>

            </DropdownMenu>
          </Dropdown>
        </Row>
        <div className="bar-container " style={chartContainerStyle}>
          {
            !error ? (
              <Chart
                options={apexBarChartOpts}
                series={data}
                type="bar"
                className="apex-charts"
                width={'100%'}
                height={500} 
              />
            ) :
              (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
                  <Alert color="warning">
                    <h4 className="alert-heading">No data available</h4>
                    <p>
                      There is no data available for this mission.
                    </p>
                    <div className="btn-list mt-4" style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                      <Button color="warning" onClick={() => setOptionsSelected([])}><i className="uil uil-refresh"></i></Button>
                    </div>
                  </Alert>
                </div>
              )
          }


        </div>
      </CardBody>
    </Card>
  );
}
